export default __webpack_public_path__ + "static/Tonic3_RGB_1-d5d402da68a51b7b07ba4efcbd4ef498.webp";